import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetOneClientRfpCount } from '@/actions/ClientRfpCountActionsTs';
import { isClient, isProfessional } from '@/utils/resources/auth/authResource';
/**
 * クライアント向けのヘッダー情報の読み込み
 * @param options
 */
const useLoadClientData = (options) => {
    const { dispatch, isIgnorePage, isTargetUser, location: { pathname }, } = options;
    useEffect(() => {
        if (!isTargetUser || isIgnorePage) {
            return;
        }
        dispatch(apiGetOneClientRfpCount({}, {}));
    }, [isTargetUser, isIgnorePage, dispatch, pathname]);
};
export const useLoadHeaderData = (options) => {
    const dispatch = useDispatch();
    const { auth } = options;
    const userType = useMemo(() => {
        if (isClient(auth)) {
            return 'client';
        }
        if (isProfessional(auth)) {
            return 'professional';
        }
        return 'guest';
    }, [auth]);
    useLoadClientData(Object.assign(Object.assign({}, options), { dispatch, isTargetUser: userType === 'client' }));
};
